export const themes = {
  dark: 'dark',
  light: 'light',
}

export const DEFAULT_THEME = themes.light
